export default function ({ route, $region, store }) {
  if (process.client) {
    store.dispatch('seo/fetchPageMeta', {
      pageUrl: route.fullPath,
      regionId: $region.getCurrentRegionId(),
    })
  }
}
